import type { Translations } from './en.js';

const es: Translations = {
  ok: 'OK',
  cancel: 'Cancelar',
  close: 'Cerrar',
  confirm: 'Confirmar',
  language: 'Idioma',

  game_title: 'Mejorar Espada',
  tap_to_start: 'Toca para empezar',
  title_load_failed: 'Error al cargar imagen de título:',
  game_started: '¡Mejorar Espada iniciado!',

  level_label: 'Lv.{n}',
  gold_suffix: 'G',
  rate_suffix: '%',
  rate_clear: '🎉 ¡Todo completado!',
  rate_display: '{rate}%',
  rate_display_boosted: '{rate}% ⬆',
  gold_display: '{amount} G',
  gold_display_free: '0 G (¡Gratis!)',

  btn_enhance: '⚒️ Mejorar',
  btn_enhance_ready: '⚔️ Mejorar',
  btn_enhance_complete: '🏆 Completo',
  btn_free_enhance: '▶ Mejora Gratis',
  btn_exhausted: 'Agotado',
  btn_boost: 'Prob\nSUBE',
  btn_applying: 'Activo\n!',
  btn_protection_active: '🛡️ Protección activa',
  btn_protection_use: '🛡️ Usar pergamino',
  btn_sell: '💰 Vender',
  btn_sell_amount: '💰 {amount}G',
  btn_shop: '🏪 Tienda',
  cost_max: 'MAX',
  cost_free: '0 G (¡Gratis!)',

  tab_settings: '⚙️ Ajustes',
  tab_inventory: '📦 Inventario',
  bgm_on: '🎵 Música ON',
  bgm_off: '🎵 Música OFF',
  sfx_on: '🔊 Sonidos ON',
  sfx_off: '🔊 Sonidos OFF',
  inventory_title: '⚔️ Armas guardadas',
  inventory_empty: 'No hay armas guardadas',
  equip: 'Equipar',
  equip_msg: '¡{name} equipada!',
  reset_confirm_title: '⚠️ ¿Reiniciar todo?',
  reset_confirm_desc: 'Se borrará todo el progreso',
  reset: 'Reiniciar',
  reset_start_over: '🔄 Empezar de nuevo',
  menu_close: 'Cerrar',

  inv_scrolls_title: '🛡️ Pergaminos',
  inv_scrolls_line1: 'Básico: {c0}  |  Medio: {c1}',
  inv_scrolls_line2: 'Alto: {c2}  |  Ultra: {c3}',
  inv_weapon_entry: '{name} (Lv.{level})',

  ad_gold_title: 'Ver anuncio para mejora gratis',
  ad_gold_desc: 'La próxima mejora cuesta 0 oro',
  ad_gold_note: '(Pergaminos y Prob. SUBE siguen activos)',
  ad_gold_confirm: '▶ Ver anuncio',
  ad_gold_free_next: '¡Próxima mejora gratis!',
  ad_gold_exhausted: '¡Usos agotados!',
  ad_gold_remaining: 'Restantes: {current}/3',

  boost_popup_title: '📺 Ver anuncio',
  boost_confirm: '▶ Ver anuncio para aplicar',
  boost_close: 'Cerrar',
  boost_applied: '¡Prob. SUBE aplicada!',
  boost_already_applied: '¡Ya está activo!',
  boost_exhausted: '¡Usos agotados!',
  boost_remaining: '🎬 Usos restantes: {current}/3',
  boost_popup_desc: 'Ahora {rate}% → x{mult}',
  boost_rate_display: '{rate}%',
  boost_mult_2x: 'x2',
  boost_mult_1_5x: 'x1.5',
  boost_mult_1_3x: 'x1.3',

  protection_popup_title: '🛡️ Usar pergamino',
  protection_use: 'Usar',
  protection_cancel: 'Cancelar',
  protection_popup_info:
    'Nivel actual: Lv.{level}\nNecesario: {name} x1\nTienes: {count}',
  protection_activated: '¡{name} activado!',
  protection_returned: '{name} devuelto',
  protection_protected: '🛡️ ¡Protegido por pergamino!',

  msg_max_level: '¡Ya está en nivel máximo!',
  msg_gold_short: '¡Oro insuficiente!',
  msg_success_boost: '¡Mejora con boost exitosa!',
  msg_success: '¡Mejora exitosa!',
  msg_destroyed: '💥 ¡DESTRUIDA!',

  shop_title: 'Tienda',
  tab_protection: 'Proteccion',
  tab_weapons: 'Comprar armas',
  weapon_shop_title: '⚔️ Comprar armas',
  item_free: 'Gratis',
  close_shop: 'Cerrar',
  buy_complete_title: '¡Compra completa!',
  buy_complete_desc: 'Los artículos comprados están en\nAjustes (arriba) → 📦 Inventario.',
  buy_complete_ok: 'OK',
  scroll_shop_label: '{name} (Lv.{min}-{max})',
  scroll_purchased: '¡{name} obtenido!',
  weapon_moved_to_inventory: '{name} → Inventario',
  price_display: '{amount}G',
  sell_received: '¡+{amount}G!',

  destroy_title: 'Arma destruida',
  destroy_ad_restore: '▶ Ver anuncio y restaurar',
  destroy_restore_ad: 'Ver anuncio y restaurar ({current}/{max})',
  destroy_give_up: 'Empezar de nuevo',
  destroy_restore_count: '🎬 Restauraciones: {current}/{max}',
  destroy_restored: 'Lv.{level} weapon restored!',
  ad_watch_fail: 'Fallo al reproducir anuncio',
  weapon_restored: '¡{name} restaurada!',

  completion_title: '¡Has completado la espada definitiva!',
  completion_all_done: '🏆 ¡Todas las mejoras completas! 🏆',
  congrats_text: '🎉 ¡Felicidades! 🎉',
  register_name: '✏️ Registrar nombre',
  prompt_register_name: 'Escribe tu nombre para el Salón de la Fama:',
  no_completion: 'Aún no hay completadores',
  be_first: '¡Sé el primero en terminar!',
  completion_close: 'Cerrar',
  leaderboard_title: '📋 Salón de la Fama',
  leaderboard_entry: '#{rank} - {name}',
  completion_rank_msg: '¡Eres el completador #{rank}!',
  completion_total_msg: '{total} jugadores han completado hasta ahora',

  weapon_image_load_failed: 'Error al cargar imagen de arma:',

  weapon_0: 'Manos desnudas',
  weapon_1: 'Daga común',
  weapon_2: 'Espada de hierro',
  weapon_3: 'Espada de plata',
  weapon_4: 'Espada snowboard',
  weapon_5: 'Espada onda',
  weapon_6: 'Espada chica mágica',
  weapon_7: 'Espada oso',
  weapon_8: 'Espada cráneo ardiente',
  weapon_9: 'Espada rayo',
  weapon_10: 'Daga lunar',
  weapon_11: 'Espada dragón',
  weapon_12: 'Espada musculosa',
  weapon_13: 'Espada rey diamante',
  weapon_14: 'Hoja creciente del dragón azul',
  weapon_15: 'Espada antigua',
  weapon_16: 'Espadas dobles del rey pirata',
  weapon_17: 'Espada chiclosa de Dubái',
  weapon_18: 'Hoja Siete-Siete',
  weapon_19: 'Báculo-espada mágico',
  weapon_20: 'Espada zumbadora',
  weapon_21: 'Espada paleta',
  weapon_22: 'Espada de la naturaleza',
  weapon_23: 'Espada cíborg',
  weapon_24: 'Espada agujero negro',
  weapon_25: 'Espada pájaro dorado',
  weapon_26: 'Espada cristal de poder',
  weapon_27: 'Espada dragón oscuro',
  weapon_28: 'Espada pinza',
  weapon_29: 'Espada IA',
  weapon_30: 'Espada motosierra',
  weapon_31: 'Espada estrella fugaz',
  weapon_32: 'Espada oscura oscura',
  weapon_33: 'Espada galáctica',
  weapon_34: 'Espada de diamante ultracara',

  scroll_basic: 'Pergamino básico',
  scroll_mid: 'Pergamino medio',
  scroll_hi: 'Pergamino alto',
  scroll_ultra: 'Pergamino ultra',
  scroll_label_basic: 'Básico',
  scroll_label_mid: 'Medio',
  scroll_label_hi: 'Alto',
  scroll_label_ultra: 'Ultra',

  // === Materials (Sprint 1) ===
  mat_iron_dust: 'Polvo de Hierro',
  mat_refining_core: 'Núcleo de Refinado',
  mat_lava_essence: 'Esencia de Lava',
  mat_abyss_crystal: 'Cristal del Abismo',

  mat_drop_notice: '+{amount} {name}',
  mat_drop_title: '¡Material Obtenido!',
  mat_double_ad: 'Ver Anuncio x2',
  mat_doubled: '¡x2 Aplicado!',
  mat_panel_title: 'Materiales',

  // === Keep / Weapon Inventory (Sprint 1) ===
  keep_btn: 'Guardar',
  keep_full: '¡Almacén Lleno!',
  keep_lv1_blocked: 'Las armas Lv.1 no se pueden almacenar',
  keep_success: '¡{name} guardado!',
  keep_retrieve: 'Equipar',
  keep_sell: 'Vender',
  keep_slot_expand: 'Ampliar Ranura',
  keep_slot_cost: '{amount}G',
  keep_slot_max: 'MAX',
  keep_slot_count: 'Ranuras: {used}/{total}',
  keep_panel_title: 'Armas Guardadas',
  keep_empty: 'No hay armas guardadas',
  keep_weapon_entry: 'Nv.{level} {name}',
  keep_sell_received: '+{amount}G',
  keep_no_slot: '¡Amplía las ranuras!',

  // === Forja (Sprint 2) ===
  tab_forge: 'Forja',
  forge_title: 'Forja',
  forge_tab_weapon: 'Armas',
  forge_tab_scroll: 'Pergaminos',
  forge_tab_upgrade: 'Mejorar Mat.',
  forge_craft_btn: 'Crear',
  forge_craft_success: '¡{name} creado!',
  forge_not_enough_mat: 'Materiales insuficientes',
  forge_weapon_to_equip: '¿Equipar ahora?',
  forge_weapon_to_keep: 'Guardar',
  forge_weapon_equip: 'Equipar',
  forge_keep_full_equip: 'Almacén lleno — equipando directamente.',
  forge_cost_label: 'Costo:',
  forge_result_label: 'Resultado:',

  forge_recipe_weapon_lv5: 'Crear Arma Nv.5',
  forge_recipe_weapon_lv10: 'Crear Arma Nv.10',
  forge_recipe_weapon_lv15: 'Crear Arma Nv.15',
  forge_recipe_weapon_lv21: 'Crear Arma Nv.21 (Piedad)',
  forge_recipe_weapon_lv21_desc: '¡Consigue un arma Lv.21 al instante, sin mejoras ni fallos!',
  forge_recipe_scroll_basic: 'Crear Pergamino Básico',
  forge_recipe_scroll_mid: 'Crear Pergamino Medio',
  forge_recipe_scroll_hi: 'Crear Pergamino Alto',
  forge_recipe_scroll_ultra: 'Crear Pergamino Ultra',
  forge_recipe_upgrade_1: 'Polvo de Hierro → Núcleo Refinado',
  forge_recipe_upgrade_2: 'Núcleo Refinado → Esencia de Lava',
  forge_recipe_upgrade_3: 'Esencia de Lava → Cristal del Abismo',

  scroll_effect_basic: 'Evita destrucción en fallo (Nv.1-9)',
  scroll_effect_mid: 'Evita destrucción en fallo (Nv.10-19)',
  scroll_effect_hi: 'Evita destrucción en fallo (Nv.20-24)',
  scroll_effect_ultra: 'Evita destrucción en fallo (Nv.25-34)',
  scroll_buy_btn: 'Comprar',

  keep_card_equip: 'Equipar',
  keep_card_sell: 'Vender',
  keep_slot_empty: 'Vacío',

  sacrifice_btn: 'Ofrecer Arma',
  sacrifice_panel_title: 'Sacrificar Armas',
  sacrifice_panel_desc: 'Ofrecer armas Nv.{level} aumenta éxito +{tierPct}% por unidad',
  sacrifice_empty: 'Sin armas Nv.{level} en almacén',
  sacrifice_bonus_label: 'Bono: +{pct}%',
  sacrifice_cap_label: '({count}/{cap})',
  sacrifice_offer_btn: 'Ofrecer',
  sacrifice_ad_slots: 'Ver anuncio: +{pct}% de éxito',
  sacrifice_ad_exhausted: 'Límite de anuncios alcanzado',
  sacrifice_ad_granted: '+3 sacrificios añadidos!',
  sacrifice_added: 'Sacrificio aceptado! +{tierPct}% bono',
  sacrifice_cap_reached: 'Límite de sacrificio alcanzado',
  sacrifice_reset: 'Bono de sacrificio reiniciado',

  infinity_btn: 'Infinito',
  infinity_active: 'GRATIS {sec}s',
  infinity_popup_title: 'Modo Infinito',
  infinity_popup_desc: '¡Mejora sin límite 10 segundos, sin oro!\nLa probabilidad es la misma: ¡aún puede romperse!',
  infinity_popup_confirm: 'Ver Anuncio',
  infinity_popup_close: 'Cerrar',
  infinity_cooldown: 'Disponible en {sec}s',
  infinity_daily_exhausted: 'Límite diario alcanzado',
  infinity_started: 'Modo Infinito ON! Gratis 10s',
  infinity_ended: 'Modo Infinito terminado',

  buff_item_luck_charm: 'Amuleto de Suerte',
  buff_item_guarantee: 'Ticket de Garantía',
  buff_item_destroy_guard: 'Guardia Anti-Rotura',
  buff_item_use: 'Usar',
  buff_item_active: 'Activo',
  buff_item_empty: '0',
  buff_luck_charm_activated: 'Amuleto activo! +5% próxima mejora',
  buff_guarantee_activated: 'Ticket activo! Próxima mejora 100%',
  buff_destroy_guard_activated: 'Guardia activo! No se rompe en próximo fallo',
  buff_luck_charm_consumed: 'Amuleto consumido',
  buff_guarantee_consumed: 'Ticket consumido',
  buff_destroy_guard_consumed: 'Guardia consumido — arma salvada!',
  buff_item_already_active: 'Ya está activo!',
  buff_item_none: 'Sin {name}',
  buff_popup_count: 'Tienes: {count}',
  buff_popup_use_btn: 'Usar Ahora',
  buff_popup_no_stock: 'No tienes ninguno. Fabrícalo en la Forja.',
  buff_popup_luck_charm_effect: '+5% de tasa de éxito en la próxima mejora',
  buff_popup_guarantee_effect: 'La próxima mejora tendrá 100% de éxito garantizado',
  buff_popup_destroy_guard_effect: 'Si falla la próxima mejora, tu arma NO se romperá',

  forge_recipe_item_luck_charm: 'Crear Amuleto de Suerte',
  forge_recipe_item_luck_charm_desc: '+5% tasa de éxito en próxima mejora',
  forge_recipe_item_guarantee: 'Crear Ticket de Garantía',
  forge_recipe_item_guarantee_desc: 'Próxima mejora 100% éxito',
  forge_recipe_item_destroy_guard: 'Crear Guardia Anti-Rotura',
  forge_recipe_item_destroy_guard_desc: 'El arma NO se romperá en el próximo fallo',
  forge_tab_item: 'Artículos',
};

export default es;
